import "./styles.scss";

const Index = ({ data }) => {
  let inputElement = null;

  inputElement = (
    <>
      <div className={`gazette-preview-wrapper`}>
        <div className="gpw-file-preview">
          {data?.file_url && (
            <iframe
              src={`${data?.file_url}#toolbar=0&navpanes=0&scrollbar=0`}
              width="100%"
              height="600px"
              style={{ border: "none" }}
              title="PDF"
            />
          )}
        </div>
      </div>
    </>
  );
  return <>{inputElement}</>;
};

export default Index;
